import React from 'react';

export interface WalkIconProps {}

export const WalkIcon: React.FC<WalkIconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
        fill="currentColor"
      ></path>
      <path
        d="M14.836 15.133a.66.66 0 0 1 .11.217l1.4 4.734a.716.716 0 0 1-.516.889.76.76 0 0 1-.909-.447l-1.672-4.413-2.815-2.707a1.013 1.013 0 0 1-.29-.93l.6-3.292-1.352.385-1.191 2.664a.635.635 0 0 1-.82.32.593.593 0 0 1-.34-.766L8.242 8.78a.626.626 0 0 1 .308-.332l.077-.037 3.008-1.478.021-.008.015-.005a.935.935 0 0 1 .6-.089c.269.05.5.199.615.425.114.226.154.641.154.641.046.256.062.508.078.76a12.356 12.356 0 0 1 .039 1.42c-.021.72-.07 1.434-.17 2.141l-.053.418 1.833 2.407.068.091z"
        fill="currentColor"
      ></path>
      <path
        d="M14.12 9.253l2.643 2.276c.27.206.316.583.103.843a.644.644 0 0 1-.858.114l-2.128-1.482.023-.129.028-.158.074-.407.026-.145.025-.142.017-.23.025-.29.01-.12.011-.13z"
        fill="currentColor"
      ></path>
      <path
        d="M10.164 14.399c.209.2.441.405.674.609.371.326.751.64 1.085.895-.142.287-.379.76-.379.76l-2.539 3.992a.768.768 0 0 1-1.031.24.707.707 0 0 1-.278-.943l2.117-3.99.029-.277c.023-.225.046-.451.077-.675l.11-.736.065.06.07.065z"
        fill="currentColor"
      ></path>
    </svg>
  );
};
